import React, {createRef, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import {defaultComponentsScroll, MaterialTableBody, FullWidthFilter} from "../../../controls/Material-Table-Components"
import SystemContext from "../../../SystemContext";
import { Icon, useTheme } from "@material-ui/core";
import { ColumnWidth } from "../../../blocks/ColumnHelper";
import useDimensions from "../../../blocks/useDimensions";

import { useCountryPermitRequirements } from "../../../services/permitRequirements";

const CountryPermitRequirementList = (_props) => {
  const {isAuthenticated} = useAuth0();

  const props = {
    ..._props
  }
  const classes = props.classes;

  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const eventBus = SystemData.eventBus;

  const handleRowClick = (event, rowData) => {
    if (eventBus) {
      eventBus.trigger('CountryPermitRequirementList.rowSelected', rowData);
    }
  }

  const tableRef = createRef({state: {lastEditingRow: false}});

  const queryClient = useQueryClient();
  const extraKeys = [];

  const countryPermitRequirements = useCountryPermitRequirements({tableRef, queryClient, extraKeys});
  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { fontSize:13, padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      filterCellStyle: { padding: "8px 2px" },
      editable: "never",
      filterComponent: FullWidthFilter
    };

    return [
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */

      {
        ...baseColumn,
        ...ColumnWidth(50),
        title: "Country",
        field: "countryCode",
      },
      {
        ...baseColumn,
        ...ColumnWidth(120),
        title: "Country Name",
        field: "countryName",
      },
      {
        ...baseColumn,
        ...ColumnWidth(120),
        title: "Permit Type",
        field: "permitType",
      },
      {
        ...baseColumn,
        cellStyle:{width: "100%"},
        filterCellStyle:{width: "100%"},
        title: "Permit Supplier",
        field: "companyName",
      },
    ];
  };

  const [tableContainerRef, {height: tableHeight}] = useDimensions({});
  const theader = tableContainerRef.current?.querySelector('thead');
  const thead = theader ? theader.clientHeight:36;
  const bodyHeight = tableHeight - thead;

  return (isAuthenticated &&
      <div style={{width: "100%", marginLeft: 20, marginRight: 20}}>
        <div style={{background: "#ffffff", width: "calc(100% - 24px)", paddingTop: 16, paddingLeft: 20, paddingRight: 4}}>
          <div ref={tableContainerRef} className={props.canEdit&&false?classes.requirementsListEdit:classes.requirementsList} style={{width: "100%", minWidth: "100%", height: `calc(100vh - ${props.height + 16}px)`}}>
            <MaterialTable
              icons={{ Filter: React.forwardRef((props, ref) => <Icon className="filterIcon">filter_list</Icon> )}}
              tableRef={tableRef}
              style={{
                border: "none",
                boxShadow: "none",
                borderRadius: 0,
              }}
              onRowClick={handleRowClick}
              options={{
                // rowStyle: rowData => ({ backgroundColor: state.selectedIndex !== undefined && rowData.tableData.id === state.selectedIndex ? '#F69259' : '' }),
                highlightRowStyle: {backgroundColor: "#F69259"},
                actionsColumnIndex: -1,
                cellStyle: {
                  padding: "8px 2px",
                },
                filterCellStyle: {
                  padding: "2px 2px",
                },
                headerRowStyle: {
                  display: "table",
                  width: "100%",
                },
                headerStyle: {
                  backgroundColor: theme.palette.tableHeader.backgroundColor,
                  color: theme.palette.tableHeader.textColor,
                  padding: 2,
                },
                toolbar: false,
                toolbarButtonAlignment: "right",
                pageSize: 15,
                detailPanelType: "single",
                padding: 'dense',
                filtering: true,
                searchFieldAlignment: "left",
                paging: false,
              }}
              components={{
                ...defaultComponentsScroll,
                Body: (props) => (
                  <MaterialTableBody
                    {...props}
                    rowHeight={46}
                    overscanRowCount={10}
                    addVirtualScrolling={true}
                    bodyHeight={bodyHeight}
                    headerHeight={thead}
                    filterRowHeight={46}
                  />
                ),
              }}
              title="Permit Requirements"
              columns={getColumns()}
              data={countryPermitRequirements.data}
          />
        </div>
      </div>
    </div>
  );

}

export default CountryPermitRequirementList;
